import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Crosshair = createReactComponent("Crosshair", ["svg", defaultAttributes, [["circle", {
  cx: "12",
  cy: "12",
  r: "10",
  key: "14id60"
}], ["line", {
  x1: "22",
  y1: "12",
  x2: "18",
  y2: "12",
  key: "gg5kc9"
}], ["line", {
  x1: "6",
  y1: "12",
  x2: "2",
  y2: "12",
  key: "h7b850"
}], ["line", {
  x1: "12",
  y1: "6",
  x2: "12",
  y2: "2",
  key: "m8s3ro"
}], ["line", {
  x1: "12",
  y1: "22",
  x2: "12",
  y2: "18",
  key: "geem49"
}]]]);
export default Crosshair;